/* eslint-disable max-len */

export default function SquareIcon() {
    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M42,11v26c0,2.757-2.243,5-5,5H11c-2.757,0-5-2.243-5-5V11c0-2.757,2.243-5,5-5h26c2.757,0,5,2.243,5,5Z" fill="#D9D9D9" />
        </svg>
    );
}
